import React, { useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { operationLog } from '../../actions/commonAction';
import { registerAccount } from '../../actions/userManagementActions';
import { handleUserManagement, openUserManagement, showAlertSnackbar } from '../../reducers/uiSlice';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import UniDialog from '../Common/UniDialog';
import { Button, Grid, MenuItem, TextField, withStyles } from '@material-ui/core';
import { getUserPreference } from '../../utilities/common';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useToken } from '../../utilities/hooks';
import { getTeamList } from "../../actions/driverActions";
import { Autocomplete } from '@material-ui/lab';
import _ from "lodash";
const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        minHeight: '80vh'
    },
    title: {
        textAlign: 'right'
    }
}));
function UserManagement(props) {
    const {
        fetchData
      } = props;
    const classes = useStyles();
    const {t} = useTranslation('userManagement');
    const dispatch = useDispatch();
    const openModal = useSelector(openUserManagement);
    const branchList = useSelector(state => state.common.branches);
    const tokenContents = useToken();
    const userPref = getUserPreference();
    const authorizedWarehouses = tokenContents.warehouse;
    const [account, setAccount] = useState('');
    const [branch, setBranch] = useState(userPref.userCity);
    const [level, setLevel] = useState('2');
    const [area, setArea] = useState('');
    const [teamList,setTeamList] = useState([]);
    const [authTeam,setAuthTeam] = useState([]);
    
    const handleAccount = (event) => {
        setAccount(event.target.value);
    }

    const handleArea = (event) => {
        setArea(event.target.value);
    }

    useEffect(() => {
        if (openModal) {
            setBranch(userPref.userCity + '');
            setArea(userPref.userCity + '');
        }
    }, [openModal])

    useEffect(() => {
        if (area > 0) {
            dispatch(getTeamList(area))
                .then((res) => {
                    setTeamList(res.data);
                    setAuthTeam([]);
                })
                .catch((err) => {
                    dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
                })
        }
    }, [area])


    return (
        <UniDialog
            title={t('title_user_management')}
            fullWidth
            maxWidth='sm'
            disableDefaultButtons
            open={openModal}
            onClose={handleClose}
        >
            <ValidatorForm>
                <Grid container spacing={4}>
                    <Grid 
                        container 
                        spacing={2}
                        item
                        xs={12}
                    >
                        <Grid item xs={12} container alignItems="center" justify="center">
                            <Grid item xs={3} className={classes.title}>
                                {t('account')}
                            </Grid>
                            <Grid item xs={1}></Grid>
                            <Grid item xs={8}>
                                <TextValidator
                                    variant="outlined"
                                    size="small"
                                    placeholder={t('input_account')}
                                    onChange={handleAccount}
                                    value={account}
                                    validators={['required', 'minStringLength:4','maxStringLength:20']}
                                    errorMessages={['this field is required', 'min length is 4', 'max length is 20']}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid 
                        container 
                        spacing ={2}
                        item
                        xs={12}
                    >
                        <Grid item xs={12} container alignItems="center" justify="center">
                            <Grid item xs={3} className={classes.title}>
                                {t('area')}
                            </Grid>
                            <Grid item xs={1}></Grid>
                            <Grid item xs={8}>
                                <TextField
                                    select
                                    variant="outlined"
                                    size="small"
                                    label={t('input_area')}
                                    onChange={handleArea}
                                    value={area}
                                    fullWidth
                                    disabled={level === '3'}
                                >
                                {
                                    branchList && 
                                    branchList.filter(
                                        (branch) => (authorizedWarehouses.includes(branch.id))
                                    ).map((option) => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.name}
                                        </MenuItem>
                                    ))
                                }
                                </TextField>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container alignItems="center" justify="center" style={{paddingTop: 16}}>
                            <Grid item xs={3} className={classes.title}>
                                {t('team')}
                            </Grid>
                            <Grid item xs={1}></Grid>
                            <Grid item xs={8}>
                                {   teamList &&
                                    <Autocomplete
                                        multiple
                                        options={teamList || []}
                                        getOptionLabel={(option) => option?.name}
                                        filterSelectedOptions
                                        limitTags={1}
                                        onChange={(event, value) => {
                                            setAuthTeam(value)
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} label={t("team_label")} variant="outlined"/>
                                        )}
                                        id="usermanagment_team_autocomplete"
                                        style={{width: 300}}
                                        placeholder="ALL"
                                        value={authTeam}
                                    />
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </ValidatorForm>
            <Grid container style={{marginTop: 20, marginBottom: 10}}>
                <Grid item xs={3}>
                </Grid>
                <Grid item xs={3}>
                </Grid>
                <Grid item xs={3}>
                </Grid>
                <Grid item xs={3}>
                    <Button
                        variant='contained'
                        color="secondary"
                        onClick={handleSubmit}
                    >
                        {t('create_user')}
                    </Button>
                </Grid>
            </Grid>
        </UniDialog>
    );
    
    function handleSubmit() {
        if(!account) {
            dispatch(showAlertSnackbar({message: t('validate_account'), type: 'error'}))
        } else if(area.length <= 0) {
            dispatch(showAlertSnackbar({message: t('validate_area'), type: 'error'}))
        } else {
            let team = authTeam.length > 0 ? _.map(authTeam,'id').toString() : "ALL"
            dispatch(registerAccount(level, account, area,team))
            .then((res) => {
                dispatch(operationLog('', userPref.username, '', 6, `CREATE_SYSTEM_USER:${account} AUTH_TEAM:${team}`))
                dispatch(showAlertSnackbar({message: 'Username: ' + res.username + ', ' + 'Password: ' + res.password,type: 'success'}))
                fetchData();
                handleClose()
            })
            .catch((err) => {
                dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
            })
        }
    }

    /**
     * close the dialog
    */
    function handleClose() {
        dispatch(handleUserManagement(false))
    }

}

export default UserManagement;